<template>
  <div class="logo">
    <router-link :to="{ name: 'dashboard' }">
      <!--<LogoSvg alt="logo" />-->
      <img v-if="$store.state.user_type == 1" src="@/assets/logo3.png" />
      <img v-else src="@/assets/logo3.jpg" />
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
import LogoSvg from '@/assets/logo.svg?inline'

export default {
  name: 'Logo',
  components: {
    LogoSvg,
  },
  props: {
    title: {
      type: String,
      default: 'LOCKAN',
      required: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
}
</script>
